import React, { useState } from "react";

const SurveyQuestionModal = ({
  isOpen,
  onClose = () => {},
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 9; // Updated to show all sections

  const dummyData = {
    SelfDirection: [
      {
        question: "Does the child follow daily routines independently?",
        selectedOption: 2
      },
      {
        question: "Can the child make simple decisions about daily activities?", 
        selectedOption: 3
      },
      {
        question: "Does the child show initiative in starting tasks or activities?",
        selectedOption: 1
      }
    ],
    Communication: [
      {
        question: "Can the child express basic needs and wants?",
        selectedOption: 2
      },
      {
        question: "Does the child respond appropriately to simple instructions?",
        selectedOption: 3
      },
      {
        question: "Can the child engage in basic conversations?",
        selectedOption: 1
      }
    ],
    FunctionalAcademics: [
      {
        question: "Can the child recognize basic numbers and count objects?",
        selectedOption: 2
      },
      {
        question: "Does the child show interest in learning activities?",
        selectedOption: 1
      },
      {
        question: "Can the child write their own name?",
        selectedOption: 3
      }
    ],
    CommunityUse: [
      {
        question: "Can the child behave appropriately in public places?",
        selectedOption: 2
      },
      {
        question: "Does the child understand basic safety rules when outside?",
        selectedOption: 1
      },
      {
        question: "Can the child follow simple routines in community settings?",
        selectedOption: 3
      }
    ],
    Leisure: [
      {
        question: "Does the child engage in play activities with peers?",
        selectedOption: 2
      },
      {
        question: "Can the child share toys and take turns?",
        selectedOption: 3
      },
      {
        question: "Does the child show interest in recreational activities?",
        selectedOption: 1
      }
    ],
    HomeLiving: [
      {
        question: "Can the child keep their personal space tidy?",
        selectedOption: 2
      },
      {
        question: "Does the child help with simple household chores?",
        selectedOption: 1
      },
      {
        question: "Can the child follow basic home safety rules?",
        selectedOption: 3
      }
    ],
    HealthAndSafety: [
      {
        question: "Does the child understand basic hygiene practices?",
        selectedOption: 2
      },
      {
        question: "Can the child identify basic safety hazards?",
        selectedOption: 3
      },
      {
        question: "Does the child follow health-related instructions?",
        selectedOption: 1
      }
    ],
    SelfCare: [
      {
        question: "Can the child dress themselves independently?",
        selectedOption: 2
      },
      {
        question: "Does the child maintain personal cleanliness?",
        selectedOption: 3
      },
      {
        question: "Can the child eat and drink independently?",
        selectedOption: 1
      }
    ],
    Social: [
      {
        question: "Does the child interact appropriately with peers?",
        selectedOption: 2
      },
      {
        question: "Can the child recognize others' emotions?",
        selectedOption: 1
      },
      {
        question: "Does the child show empathy towards others?",
        selectedOption: 3
      }
    ]
  };

  const handleNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const getCurrentQuestions = () => {
    switch(currentStep) {
      case 1:
        return dummyData.SelfDirection;
      case 2:
        return dummyData.Communication;
      case 3:
        return dummyData.FunctionalAcademics;
      case 4:
        return dummyData.CommunityUse;
      case 5:
        return dummyData.Leisure;
      case 6:
        return dummyData.HomeLiving;
      case 7:
        return dummyData.HealthAndSafety;
      case 8:
        return dummyData.SelfCare;
      case 9:
        return dummyData.Social;
      default:
        return [];
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-3/4 max-h-[80vh] overflow-y-auto rounded-lg shadow-lg p-6">
        <div className="d-flex flex-column align-items-center gap-3">
          <div className="d-flex align-items-center gap-20">
            {[...Array(totalSteps)].map((_, index) => (
              <div key={index} className="position-relative">
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center`}
                  style={{
                    width: "35px",
                    height: "35px",
                    border: "1px solid #ccc",
                    backgroundColor: index + 1 <= currentStep ? "#241763" : "white",
                    color: index + 1 <= currentStep ? "white" : "black",
                    position: "relative",
                    zIndex: 2
                  }}
                >
                  {index + 1}
                </div>
                {index < totalSteps - 1 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "100%",
                      width: "80px",
                      height: "3px",
                      backgroundColor: index + 1 < currentStep ? "#241763" : "#ccc",
                      zIndex: 1
                    }}
                  />
                )}
              </div>
            ))}
          </div>

          <div className="mt-3">
            {currentStep === 1 && <div className="fw-bold text-xl">Self Direction</div>}
            {currentStep === 2 && <div className="fw-bold text-xl">Communication</div>}
            {currentStep === 3 && <div className="fw-bold text-xl">Functional Academics</div>}
            {currentStep === 4 && <div className="fw-bold text-xl">Community Use</div>}
            {currentStep === 5 && <div className="fw-bold text-xl">Leisure</div>}
            {currentStep === 6 && <div className="fw-bold text-xl">Home Living</div>}
            {currentStep === 7 && <div className="fw-bold text-xl">Health and Safety</div>}
            {currentStep === 8 && <div className="fw-bold text-xl">Self Care</div>}
            {currentStep === 9 && <div className="fw-bold text-xl">Social</div>}
          </div>

          <div className="mt-4 w-100">
            <div className="d-flex justify-content-between mb-3 px-4">
              <span>0 = Not true at all (Never, seldom)</span>
              <span>2 = Pretty much true (often, Quite a bit)</span>
            </div>
            <div className="d-flex justify-content-between mb-4 px-4">
              <span>1 = Just a little true (Occasionally)</span>
              <span>3 = Very much true (Very often, Very frequently)</span>
            </div>

            {getCurrentQuestions().map((item, index) => (
              <div key={index} className="mb-4">
                <div className="d-flex align-items-start gap-4">
                  <div className="flex-grow-1">
                    <span className="me-2">{index + 1}.</span>
                    {item.question}
                  </div>
                  <div className="d-flex gap-3">
                    {[0, 1, 2, 3].map((value) => (
                      <div key={value} className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name={`question-${index}`}
                          id={`question-${index}-${value}`}
                          value={value}
                          checked={value === item.selectedOption}
                          readOnly
                        />
                        <label className="form-check-label" htmlFor={`question-${index}-${value}`}>
                          {value}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button 
            className="btn btn-secondary" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={handlePrevious}
            disabled={currentStep === 1}
          >
            Previous
          </button>
          {currentStep === totalSteps ? (
            <button className="btn btn-primary" onClick={onClose}>Close</button>
          ) : (
            <button 
              className="btn btn-primary" 
              onClick={handleNext}
            >
              Next
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SurveyQuestionModal;
